// Generated by purs version 0.14.4
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Traversable from "../Data.Traversable/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_WeakDynamic from "../Specular.FRP.WeakDynamic/index.js";
import * as Unsafe_Reference from "../Unsafe.Reference/index.js";
var updateList = function (dictMonadFRP) {
    return function (latestRef) {
        return function (mainSlot) {
            return function (handler) {
                return function (newArray) {
                    return function __do() {
                        var latest = Effect_Ref.read(latestRef)();
                        var newEntries = Data_Functor.map(Effect.functorEffect)(Data_Array.concat)(Data_Function.flip(Data_Traversable.traverse(Data_Traversable.traversableArray)(Effect.applicativeEffect))(Data_Array.range(0)(Data_Ord.max(Data_Ord.ordInt)(Data_Array.length(newArray))(Data_Array.length(latest))))(function (i) {
                            var v = Data_Array.index(newArray)(i);
                            var v1 = Data_Array.index(latest)(i);
                            if (v1 instanceof Data_Maybe.Just && v instanceof Data_Maybe.Just) {
                                return function __do() {
                                    $foreign.nextMicrotask(v1.value0.fire(v.value0))();
                                    return [  ];
                                };
                            };
                            if (v1 instanceof Data_Maybe.Just && v instanceof Data_Maybe.Nothing) {
                                return function __do() {
                                    Control_Monad_Replace.destroySlot(v1.value0.slot)();
                                    return [  ];
                                };
                            };
                            if (v1 instanceof Data_Maybe.Nothing && v instanceof Data_Maybe.Just) {
                                return function __do() {
                                    var slot = Control_Monad_Replace.appendSlot(mainSlot)();
                                    var v2 = Specular_FRP_Base.newEvent(Effect_Class.monadEffectEffect)();
                                    var result = Control_Monad_Replace.replaceSlot(slot)(Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.holdUniqDynBy(dictMonadFRP)(Unsafe_Reference.unsafeRefEq)(v.value0)(v2.event))(function (dyn) {
                                        return handler(i)(dyn);
                                    }))();
                                    return [ {
                                        slot: slot,
                                        fire: v2.fire,
                                        result: result
                                    } ];
                                };
                            };
                            if (v1 instanceof Data_Maybe.Nothing && v instanceof Data_Maybe.Nothing) {
                                return Control_Applicative.pure(Effect.applicativeEffect)([  ]);
                            };
                            throw new Error("Failed pattern match at Specular.FRP.List (line 89, column 5 - line 104, column 16): " + [ v1.constructor.name, v.constructor.name ]);
                        }))();
                        var newLatest = Data_Array.take(Data_Array.length(newArray))(Data_Semigroup.append(Data_Semigroup.semigroupArray)(latest)(newEntries));
                        Effect_Ref.write(newLatest)(latestRef)();
                        return Data_Functor.map(Data_Functor.functorArray)(function (v) {
                            return v.result;
                        })(newLatest);
                    };
                };
            };
        };
    };
};
var weakDynamicListWithIndex = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dynArray) {
            return function (handler) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(Effect_Ref["new"]([  ])))(function (v) {
                    return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Replace.newSlot(dictMonadReplace))(function (mainSlot) {
                        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (resultChanged) {
                            var handler$prime = function (i) {
                                return function (dyn) {
                                    return handler(i)(Specular_FRP_WeakDynamic.weaken(dyn));
                                };
                            };
                            return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_WeakDynamic.subscribeWeakDyn_(dictMonadFRP)(Control_Bind.composeKleisli(Effect.bindEffect)(updateList(dictMonadFRP)(v)(mainSlot)(handler$prime))(resultChanged.fire))(dynArray))(function () {
                                return Specular_FRP_WeakDynamic.holdWeakDyn(dictMonadFRP)(resultChanged.event);
                            });
                        });
                    });
                });
            };
        };
    };
};
var weakDynamicList = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dynArray) {
            return function (handler) {
                return weakDynamicListWithIndex(dictMonadFRP)(dictMonadReplace)(dynArray)(function (v) {
                    return handler;
                });
            };
        };
    };
};
var weakDynamicListWithIndex_ = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dynArray) {
            return function (handler) {
                return Data_Functor["void"](((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(weakDynamicListWithIndex(dictMonadFRP)(dictMonadReplace)(dynArray)(handler));
            };
        };
    };
};
var weakDynamicList_ = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dynArray) {
            return function (handler) {
                return Data_Functor["void"](((((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1()).Apply0()).Functor0())(weakDynamicListWithIndex(dictMonadFRP)(dictMonadReplace)(dynArray)(function (v) {
                    return handler;
                }));
            };
        };
    };
};
var dynamicListWithIndex_ = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dynArray) {
            return function (handler) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(Effect_Ref["new"]([  ])))(function (v) {
                    return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Replace.newSlot(dictMonadReplace))(function (mainSlot) {
                        return Specular_FRP_Base.subscribeDyn_(dictMonadFRP)((function () {
                            var $40 = Data_Functor["void"](Effect.functorEffect);
                            var $41 = updateList(dictMonadFRP)(v)(mainSlot)(handler);
                            return function ($42) {
                                return $40($41($42));
                            };
                        })())(dynArray);
                    });
                });
            };
        };
    };
};
var dynamicList_ = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dynArray) {
            return function (handler) {
                return dynamicListWithIndex_(dictMonadFRP)(dictMonadReplace)(dynArray)(function (v) {
                    return handler;
                });
            };
        };
    };
};
var dynamicListWithIndex = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dynArray) {
            return function (handler) {
                return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadFRP.MonadEffect0())(Effect_Ref["new"]([  ])))(function (v) {
                    return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Control_Monad_Replace.newSlot(dictMonadReplace))(function (mainSlot) {
                        return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.newEvent(dictMonadFRP.MonadEffect0()))(function (resultChanged) {
                            return Control_Bind.bind(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.holdDyn(dictMonadFRP)([  ])(resultChanged.event))(function (result) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(((dictMonadFRP.MonadCleanup1()).Monad0()).Bind1())(Specular_FRP_Base.subscribeDyn_(dictMonadFRP)(Control_Bind.composeKleisli(Effect.bindEffect)(updateList(dictMonadFRP)(v)(mainSlot)(handler))(resultChanged.fire))(dynArray))(function () {
                                    return Control_Applicative.pure(((dictMonadFRP.MonadCleanup1()).Monad0()).Applicative0())(result);
                                });
                            });
                        });
                    });
                });
            };
        };
    };
};
var dynamicList = function (dictMonadFRP) {
    return function (dictMonadReplace) {
        return function (dynArray) {
            return function (handler) {
                return dynamicListWithIndex(dictMonadFRP)(dictMonadReplace)(dynArray)(function (v) {
                    return handler;
                });
            };
        };
    };
};
export {
    dynamicListWithIndex,
    dynamicList,
    dynamicListWithIndex_,
    dynamicList_,
    weakDynamicListWithIndex,
    weakDynamicList,
    weakDynamicListWithIndex_,
    weakDynamicList_
};
//# sourceMappingURL=index.js.map
